import { useCallback } from 'react';
import { api } from '@sib/api';
import { downloadBlobAsFile } from '@spendbrain/utils/files';

interface useDownloadBlobFileProps {
  onError?: (error: Error, invoiceId?: string) => void;
}

export const useDownloadBlobFile = ({ onError }: useDownloadBlobFileProps) => {
  const downloadBlobFile = useCallback(
    async (
      fileUrl: string,
      filenameWithExtension: string,
      invoiceId?: string
    ) => {
      try {
        const response = await api.instance.get(fileUrl, {
          responseType: 'blob',
        });
        if (!(response.data instanceof Blob))
          throw new Error('Invalid file response format');

        downloadBlobAsFile(response.data, filenameWithExtension);
      } catch (error) {
        onError?.(error as Error, invoiceId);
      }
    },
    [onError]
  );

  return { downloadBlobFile };
};
